import axios from "axios";

export const instance = axios.create({
  baseURL: process.env.VUE_APP_RESPONSE_API,
  withCredentials: true,
});

export const googleInstance = axios.create({
  baseURL: process.env.VUE_APP_RESPONSE_API,
  params: { 
    key: process.env.VUE_APP_GOOGLE_API_KEY
  }
});

export default instance;
